var _ = require('../util')

module.exports = {

  bind: function () {
    this.attr = this.el.nodeType === 3
      ? 'nodeValue'
      : 'textContent'
  },

  update: function (value) {
    this.el[this.attr] = _.toString(value)
  }
  
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/directives/text.js
 ** module id = 29
 ** module chunks = 0
 **/